<template>
  <b-container>
    <b-row>
      <b-col class="py-3" cols="12">
          <div class="d-flex align-items-center justify-content-between">
              <h5 class="text-muted mt-2">Торги</h5>
              <div class="d-flex align-items-center">
                  <!-- Добавляем Datepicker -->
                  <b-form-datepicker
                      v-if="isAdmin"
                      v-model="torgiGovDate"
                      class="mr-2"
                      placeholder="Дата"
                      :max="today"
                      reset-button
                      size="sm"
                      style="width: 160px;"
                      locale="ru"
                  ></b-form-datepicker>

                  <b-button v-if="isAdmin"
                            size="sm"
                            variant="primary"
                            @click="getLotsFromTorgiGov"
                            :disabled="loadingTorgiGov"
                  >
                      <b-spinner v-if="loadingTorgiGov" small></b-spinner>
                      Добавить лоты из Torgi.gov
                  </b-button>

                  <b-button v-if="isAdmin" :to="{ name: 'admin-lots-create' }" size="sm" variant="success" class="ml-2">
                      Добавить лот
                      <fa :icon="['fas', 'plus']"></fa>
                  </b-button>
              </div>
          </div>

        <lots-filters
            :exclude-filters="excludeFilters"
            :saved-filters="filters"
            class="my-3"
            @filtersChanged="filtersChanged"
        />

        <b-overlay :show="loading" rounded spinner-small spinner-variant="success">
          <lots-table
              :is-admin="isAdmin"
              :is-organizer="isOrganizer"
              :items="list"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              @sort-changed="sortChanged"
          />
        </b-overlay>

        <app-pagination v-if="meta && meta.total > meta.per_page" :meta="meta" align="fill" @change="getData"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus'
import {library} from '@fortawesome/fontawesome-svg-core'
import AppPagination from '@/components/core/AppPagination.vue'
import LotsTable from '@features/Lots/LotsTable'
import LotsFilters from '@features/Lots/LotsFilters'

import {mapActions, mapMutations, mapState} from 'vuex'

library.add(faPlus);

const LOTS_STORAGE = "Lots";

export default {
  name: "Lots",
  components: {LotsFilters, LotsTable, AppPagination},
  data: () => ({
    currentPage: 1,
    excludeFilters: [],
    loadingTorgiGov: false,
    torgiGovDate: new Date().toISOString().split('T')[0]
  }),
  computed: {
    ...mapState(LOTS_STORAGE, ["list", "loading", "meta", "filters", "sort", "error"]),
    ...mapState("Profile", {profile: "data"}),
    sortBy() {
      return this.sort.sortBy;
    },
    sortDesc() {
      return this.sort.sortDirection === "desc";
    },
    isAdmin() {
      const role = this.$auth?.watch?.data?.role
      return ["admin", "operator", "operator-buhgalter"].includes(role)
    },
    isOrganizer() {
      const role = this.$auth?.watch?.data?.role
      return ["organizer"].includes(role)
    },
    today() {
       // Запрещаем выбирать даты из будущего
       return new Date().toISOString().split('T')[0];
    },
  },
  watch: {
    loadedCurrentPage() {
      this.currentPage = this.loadedCurrentPage ?? 1;
    },
    profile() {
      this.updateExcludedFilters();
      this.getData();
    },
  },
  created() {
    this.updateExcludedFilters();
  },
  mounted() {
    this.setFromUser(false);
    if(!this.$auth.check()) {
      this.preloadLots();
    } else {
      this.getData();
    }
  },
  methods: {
    ...mapActions(LOTS_STORAGE, ['fetchLots','preloadLots']),
    ...mapMutations(LOTS_STORAGE, ["setFilters", "setSort", "setFromUser"]),
    filtersChanged(filters) {
      this.setFilters(filters);
      this.getData();
    },
      getLotsFromTorgiGov() {
          this.loadingTorgiGov = true;

          axios.get('/admin/torgi-gov/notices', { params: { date: this.torgiGovDate } })
              .then(resp => {
                  this.$notify(
                      resp.data.message || 'Задача на загрузку лотов поставлена в очередь',
                      'success',
                      { timeout: 5000 }
                  );
              })
              .catch(err => {
                  if (err.response && err.response.status === 409) {
                      this.$notify(
                          err.response.data.message,
                          'warning',
                          { timeout: 10000 }
                      );
                  } else {
                      this.$notify(
                          'Произошла ошибка при запуске импорта',
                          'error',
                          { timeout: 5000 }
                      );
                  }
              })
              .finally(() => this.loadingTorgiGov = false);
      },
    sortChanged(data) {
      const params = {
        sortBy: data.sortBy,
        sortDirection: data.sortDesc ? "desc" : "asc",
      };
      this.setSort(params);
      this.getData()
    },
    updateExcludedFilters() {
      this.excludeFilters = this.isAdmin ? [] : ["draft"];
    },
    async getData(page) {
      await this.fetchLots(page)
      if (this.error) {
        this.$notify(this.error, 'error', {timeout: 10000})
      }
    }
  },
};
</script>
